import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  faqHowToApplyHeader: {
    id: "funding-application: additional funding faq who to apply header",
    defaultMessage: "How do I apply for additional funding?",
  },
  faqSubmitNewFundingApplicationHeader: {
    id: "funding-application: additional funding faq submit new funding application header",
    defaultMessage: "Submit a new funding application",
  },
  faqSubmitNewFundingApplicationBody: {
    id: "funding-application: additional funding faq submit new funding application body",
    defaultMessage: `
    <p>You can request an additional advance through the "Funding Request" tab.</p>
    <p>
      You will need to let us know how much you are looking for, what it is for and when you want to receive the funds.
    </p>
    `,
  },
  faqReviewDataHeader: {
    id: "funding-application: additional funding faq review data header",
    defaultMessage: "We review data from your connected platforms and ask for additional information if required",
  },
  faqReviewDatabody: {
    id: "funding-application: additional funding faq review data body",
    defaultMessage: `
    <p>
      We may require additional information from you and will notify you if it's required. This may mean
      uploading bank statements or reconnecting your platform or bank again.
    </p>
    <p>
      To avoid any delays to your request, please ensure all of your platforms are connected and up to date using the <x>Connections</x> tab
    </p>
    `,
  },
  faqReviewAndSelectOffersHeader: {
    id: "funding-application: additional funding faq review and select offers header",
    defaultMessage: "Review and select your offers",
  },
  faqReviewAndSelectOffersBody: {
    id: "funding-application: additional funding faq review and select offers body",
    defaultMessage:
      "If your request for an additional advance is successful, you will be able to choose a financing offer that works best for your business.",
  },
  faqAcceptContractReceiveFundingHeader: {
    id: "funding-application: additional funding faq accept contract receive funding header",
    defaultMessage: "Accept contract and receive funding",
  },
  faqAcceptContractReceiveFundingBody: {
    id: "funding-application: additional funding faq accept contract receive funding body",
    defaultMessage: `
    <p>Once you select an offer you'll have a new contract to sign. We then can send the funds to your bank within 1 - 3 days, depending on how long it takes your bank to receive it.</p>
    <p>Please note, we may require you to complete KYC again, but only if it's been more than 12 months since your last funding.</p>
    `,
  },
  faqWhoIsEligibleHeader: {
    id: "funding-application: additional funding faq who is eligible header",
    defaultMessage: "Who is typically eligible for additional funding?",
  },
  faqWhoIsEligibleBody: {
    id: "funding-application: additional funding faq who is eligible body",
    defaultMessage: `
    <p>
      Typically, customers who have repaid >60% of their cash advance are eligible for a review. Eligibility is based on your business performance and the balance of your outstanding advances.
    </p>
    <p>
      Customers who initially took less funding than they qualified for may be able to come to us sooner than the 60% mark.
    </p>
    <p>If you have any further questions, please reach out to us <x>here</x>, or contact your Wayflyer representative if you have one</p>
    `,
  },
  faqHowLongHeader: {
    id: "funding-application: additional funding faq how long header",
    defaultMessage: "How long will it take to review my application?",
  },
  faqHowLongBody: {
    id: "funding-application: additional funding faq how long body",
    defaultMessage:
      "After you've submitted a request for additional advances, you can expect to hear back from us within <b>1 - 2 business days.</b>",
  },
  faqWhenReceiveFundsHeader: {
    id: "funding-application: additional funding faq when receive funds header",
    defaultMessage: "When can I expect to receive my funds?",
  },
  faqWhenReceiveFundsBody: {
    id: "funding-application: additional funding faq when receive funds body",
    defaultMessage: `
    <p>Once you're happy with an offer and have signed your contract, funds will be in your account within <b>1 - 3 days</b>, depending on how long it takes your bank to receive it.</p>
    <p>Please be aware, we cannot send funds on weekends and public holidays.</p>
    `,
  },
  faqHelpHeader: {
    id: "funding-application: additional funding faq help header",
    defaultMessage: "I need help",
  },
  faqHelpBody: {
    id: "funding-application: additional funding faq help body",
    defaultMessage:
      "If you need help with an additional advance request or for anything else, please reach out to us via our <x>live chat</x> or contact your Wayflyer representative directly if you have one.",
  },
});
